"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiClient = exports.ApiError = void 0;
const i18next_1 = __importDefault(require("i18next"));
class ApiError extends Error {
    status;
    errors;
    constructor(status, message, errors) {
        super(message);
        this.status = status;
        this.errors = errors;
    }
}
exports.ApiError = ApiError;
const parseErrorBody = (text) => {
    try {
        const body = JSON.parse(text);
        return typeof body === 'object' && body !== null ? body : undefined;
    }
    catch {
        return undefined;
    }
};
// A 400/409 body is { errors, message }. Paused gets its own wording: it is the
// one refusal an operator fixes on another screen (配信再開), not in the form.
const errorMessage = (status, text, body) => {
    if (status === 403)
        return i18next_1.default.t('errors.forbidden');
    if (body?.errors?.paused)
        return i18next_1.default.t('errors.paused');
    return body?.message ?? text;
};
// 401 here means "your session expired mid-use" (a protected resource
// rejected you) — redirect to sign in. AuthProvider's own initial check
// calls fetch() directly instead of this client, since a 401 there just
// means "not signed in yet," which is the normal first-load state, not
// something to react to as a failure.
const request = async (path, init) => {
    const response = await fetch(path, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', ...init?.headers },
        ...init,
    });
    if (response.status === 401) {
        if (window.location.pathname !== '/login') {
            window.location.assign('/login');
        }
        throw new ApiError(401, 'Not signed in');
    }
    if (!response.ok) {
        const text = await response.text();
        const body = parseErrorBody(text);
        throw new ApiError(response.status, errorMessage(response.status, text, body), body?.errors);
    }
    if (response.status === 204) {
        return undefined;
    }
    return (await response.json());
};
exports.apiClient = {
    get: (path) => request(path),
    post: (path, body) => request(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
    put: (path, body) => request(path, { method: 'PUT', body: body ? JSON.stringify(body) : undefined }),
    delete: (path) => request(path, { method: 'DELETE' }),
};
